import { setHtml } from '@webapp/common/lib/ui';

export const CompleteText: FC<{
    completePageText: string;
    style: CSSProperties;
}> = ({ completePageText, style }) => <div style={style} {...setHtml(completePageText)} />;
